import { render, staticRenderFns } from "./WebPartHotProductsDesigner.vue?vue&type=template&id=7b6d4868&scoped=true&"
import script from "./WebPartHotProductsDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartHotProductsDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartHotProductsDesigner.vue?vue&type=style&index=0&id=7b6d4868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d4868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6d4868')) {
      api.createRecord('7b6d4868', component.options)
    } else {
      api.reload('7b6d4868', component.options)
    }
    module.hot.accept("./WebPartHotProductsDesigner.vue?vue&type=template&id=7b6d4868&scoped=true&", function () {
      api.rerender('7b6d4868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartHotProductsDesigner.vue"
export default component.exports